import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Keep existing ad links working: open the campaign's own page, which opens
 * the ad alongside it (and hands phones to the campaigns list panel).
 */
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/advertising/$id/ads/$adId'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/l/$locationId/marketing/advertising/$id',
      params: { locationId: params.locationId, id: params.id },
      search: { ad: params.adId },
      replace: true,
    });
  },
});
